import { apiGet, ApiRequestError } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { IAlertFallDetection } from '@/api/notification/getNotificationFallDetection.ts'

export const apiGetFallDetectionDetail = async (id?: number) => {
    return await apiGet<IAlertFallDetection>(`/alert/falldetection/${id}`)
}

const useQueryGetFallDetectionDetail = (id?: number) => {
    return useQuery({
        queryKey: QueryCacheKeys.notification.getFallDetectionDetail(id),
        // 알림센터 목록 응답에는 처리내용(content)이 생략될 수 있으므로
        // 실시간 모드가 아니어도 상세 데이터는 반드시 한 번 조회한다.
        enabled: (id ?? -1) >= 0,
        retry: (failureCount, error) =>
            !(error instanceof ApiRequestError && error.status === 404) && failureCount < 2,
        queryFn: async () => {
            const { data } = await apiGetFallDetectionDetail(id)
            return data
        }
    })
}

export default useQueryGetFallDetectionDetail
